import React from 'react';
import { Card } from '../../../components/Card';
import { Section } from '../../../components/Section';
import { IconWrap } from '../../../components/IconWrap';
import useTheme from '../../../hooks/useTheme';
import { megaGreenData } from '../../../data/data';
import { CiTrash } from 'react-icons/ci';
import { BiBoltCircle, BiLeaf } from 'react-icons/bi';

interface WhatWeDoProps {
    index?: number;
}

export const WhatWeDo: React.FC<WhatWeDoProps> = ({ index }) => {
    const { theme, breakpoint } = useTheme();
    const pillars = megaGreenData.home.pillars;

    const iconMap: Record<string, React.ReactNode> = {
        leaf: <BiLeaf />,
        bolt: <BiBoltCircle />,
        recycle: <CiTrash />,
    };

    return (
        <Section index={index}>
            <h2
                style={{
                    fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                    fontWeight: 700,
                    color: theme.text.primary,
                    marginBottom: '48px',
                    textAlign: 'center',
                }}
            >
                What we do
            </h2>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : 'repeat(3, 1fr)',
                    gap: '24px',
                }}
            >
                {pillars.map((pillar, idx) => (
                    <Card key={idx} hoverable>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                marginBottom: '16px',
                            }}
                        >
                            <IconWrap
                                icon={iconMap[pillar.icon] || <BiLeaf />}
                                size={32}
                                color="primary"
                                withBackground={true}
                            />
                            <h3
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 600,
                                    color: theme.text.primary,
                                }}
                            >
                                {pillar.title}
                            </h3>
                        </div>
                        <p
                            style={{
                                fontSize: '16px',
                                color: theme.text.muted,
                                lineHeight: 1.6,
                                marginBottom: '16px',
                            }}
                        >
                            {/* {pillar.description} */}
                        </p>
                        {/* <PlaceholderImage
                            label="SECTOR PHOTO"
                            height={120}
                            style={{ borderRadius: theme.borderRadius.r1 }}
                        /> */}
                        <img src={pillar.src} alt={pillar.imageAlt} style={{
                            width: '100%', height: 200, objectFit: 'cover',
                            borderRadius: theme.borderRadius.r1
                        }} />
                    </Card>
                ))}
            </div>
        </Section>
    );
};

